import axios from "axios";

export default {
  namespaced: true,
  state() {
    return {
      newsList: [],
      detailNews: {},
      isLoadingComplete: false,
    };
  },
  getters: {
    getNewsList(state) {
      return state.newsList;
    },
    getNewsDetail(state) {
      return state.detailNews;
    },
    isLoadingComplete(state) {
      return state.isLoadingComplete;
    },
  },
  mutations: {
    setNewsList(state, news) {
      state.newsList = news.data;
    },
    setDetailNews(state, news) {
      state.detailNews = news.data;
    },
    setIsLoadingComplete(state, value) {
      state.isLoadingComplete = value;
    },
  },
  actions: {
    async fetchNews({ commit }, { limit = 0, preview = 0 }) {
      commit("setIsLoadingComplete", false);
      try {
        const response = await axios.get(
          `https://stage-ms.theearplatform.com/v1/cms/bulk/blogs/post?limits=${limit}&preview=${preview}`,
          {
            auth: {
              username: "4001",
              password: "X47D3LRtL8564R7Gdszkqj4SkLdR8hEs",
            },
          }
        );
        commit("setNewsList", response);
        commit("setIsLoadingComplete", true);
      } catch (error) {
        console.error("Errore durante il recupero delle news:", error);
      }
    },

    async fetchDetailNews({ commit }, { slug, id }) {
      commit("setIsLoadingComplete", false);
      try {
        const response = await axios.get(
          `https://stage-ms.theearplatform.com/v1/cms/blogs/${slug}/${id}`,
          {
            auth: {
              username: "4001",
              password: "X47D3LRtL8564R7Gdszkqj4SkLdR8hEs",
            },
          }
        );
        commit("setDetailNews", response);
        commit("setIsLoadingComplete", true);
      } catch (error) {
        console.error("Errore durante il recupero delle news:", error);
      }
    },
  },
};
